<template>
  <div class="flex flex-col md:flex-row md:justify-between">
    <div class="w-64 flex-shrink-0">
      <span class="text-grayDark font-medium" for="media_kit_url">Media Kit link</span>
    </div>
    <div class="md:ml-8 mt-1 md:mt-0 flex-1 flex items-center justify-between">
      <div v-if="! edit" class="w-full flex items-center justify-between">
        <span class="font-semibold">{{ model.media_kit_url }}</span>
        <Edit @edit="edit = true"/>
      </div>
      <div v-else class="w-full">
        <ValidationObserver ref="mediaKitLinkForm" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(update)" method="post">
            <div>
              <ValidationProvider mode="lazy" rules="url|max:255" vid="media_kit_url" name="Media Kit url" v-slot="{ errors }">
                <div>
                  <div class="rounded-lg shadow-sm">
                    <label for="media_kit_url" class="sr-only">Media Kit link</label>
                    <input name="media_kit_url" id="media_kit_url" type="text" class="guestio-form-input" v-model="form.media_kit_url" placeholder="Type or paste URL..." />
                  </div>
                  <p class="text-red-500 text-sm mt-1 font-light" v-if="errors.length">{{ errors[0] }}</p>
                </div>
              </ValidationProvider>
            </div>
            <div class="mt-4 flex items-center justify-end">
              <SaveOrCancel @cancel="edit = false" :working="working"/>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
  import Edit from "@/components/shared/Edit";
  import SaveOrCancel from "@/components/shared/SaveOrCancel";

  export default {
    components: {Edit, SaveOrCancel},

    props: {
      model: Object,
      entity: String,
    },

    data() {
      return {
        working: false,
        edit: false,
        form: {
          media_kit_url: null,
        }
      }
    },

    computed: {
      updateAction() {
        return this.entity == 'guest' ? 'guest/updateGuest' : 'shows/updateShow'
      },
    },

    watch: {
      model(){
        if (this.model) {
          this.form.media_kit_url = this.media_kit_url
        }
      },

      edit(edit) {
        if (edit) return

        this.form.media_kit_url = this.model.media_kit_url
      }
    },

    methods: {
      update() {
        this.working = true

        this.$store.dispatch(this.updateAction, {
          id: this.model.id,
          media_kit_url: this.form.media_kit_url,
        })
          .then(() => {
            this.working = false
            this.edit = false
          })
          .catch(error => {
            this.working = false
            if (error.response) {
              this.$refs.mediaKitLinkForm.setErrors(error.response.data.errors)
            }
          })
      }
    }
  }
</script>
